import { render, staticRenderFns } from "./PublicEventoDetail.vue?vue&type=template&id=11d08b52&scoped=true"
import script from "./PublicEventoDetail.vue?vue&type=script&lang=js"
export * from "./PublicEventoDetail.vue?vue&type=script&lang=js"
import style0 from "./PublicEventoDetail.vue?vue&type=style&index=0&id=11d08b52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d08b52",
  null
  
)

export default component.exports